<div class="overlay-medium">
  <app-card-medium
    title="{{ data?.name }}"
    description="{{ data?.description }}"
    [coordinate]="data?.coordinate"
    [isShowTable]="true"
  >
    <ul *ngIf="!splitScreenOn" class="nav">
      <li class="nav-item">
        <a
          class="nav-link d-flex flex-column align-items-center"
          routerLinkActive="active"
          routerLink="summary"
          data-cy="detailSummaryNav"
          (click)="selectModule('')"
        >
          <i class="icon-graph"></i>
          <small class="mt-1">{{ "summary" | translate }}</small>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link d-flex flex-column align-items-center"
          routerLinkActive="active"
          routerLink="annotations"
          data-cy="detailAnnotNav"
          (click)="selectModule('')"
        >
          <i class="icon-annotation"></i>
          <small class="mt-1">{{ "annotations" | translate }}</small>
        </a>
      </li>
      <!-- <li class="nav-item">
        <a class="nav-link d-flex flex-column align-items-center" routerLinkActive="active" routerLink="discussions">
          <i class="icon-discussion"></i>
          <small class="mt-1">{{ 'comments' | translate }}</small></a>
      </li> -->
      <li class="nav-item">
        <a
          class="nav-link d-flex flex-column align-items-center"
          routerLinkActive="active"
          routerLink="tasks"
          data-cy="detailTaskNav"
          (click)="selectModule('')"
        >
          <i class="icon-tasks"></i>
          <small class="mt-1">{{ "tasks" | translate }}</small></a
        >
      </li>
      <li class="nav-item" *ngIf="showVid">
        <a
          class="nav-link d-flex flex-column align-items-center"
          routerLinkActive="active"
          routerLink="videos"
          data-cy="detailVideoNav"
          (click)="selectModule('videos')"
        >
          <i class="icon-files"></i>
          <small class="mt-1">{{ "videos" | translate }}</small></a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link d-flex flex-column align-items-center"
          routerLinkActive="active"
          routerLink="gallery"
          data-cy="detailGalleryNav"
          (click)="selectModule('')"
        >
          <i class="icon-files"></i>
          <small class="mt-1">{{ "gallery" | translate }}</small></a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link d-flex flex-column align-items-center"
          routerLinkActive="active"
          routerLink="attachment"
          data-cy="detailAttachmentNav"
          (click)="selectModule('')"
        >
          <i class="icon-files"></i>
          <small class="mt-1">{{ "attachments" | translate }}</small></a
        >
      </li>
      <li
        class="nav-item"
        *ngIf="permissions && permissions['read:any.audittrail']"
        (click)="selectModule('')"
      >
        <a
          class="nav-link d-flex flex-column align-items-center"
          routerLinkActive="active"
          routerLink="history"
          data-cy="detailHistoryNav"
        >
          <i class="icon-history"></i>
          <small class="mt-1">{{ "history" | translate }}</small></a
        >
      </li>
      <li class="nav-item" (click)="selectModule('')" *ngIf="data?.faq_enabled">
        <a
          class="nav-link d-flex flex-column align-items-center"
          routerLinkActive="active"
          routerLink="faq"
          data-cy="detailFaqNav"
        >
          <i class="icon-horizontal-ellipsis"></i>
          <small class="mt-1">{{ "faq" | translate }}</small></a
        >
      </li>
      <li class="nav-item" (click)="selectModule('')">
        <a
          class="nav-link d-flex flex-column align-items-center"
          routerLinkActive="active"
          routerLink="info"
          data-cy="detailInfoNav"
        >
          <i class="icon-horizontal-ellipsis"></i>
          <small class="mt-1">{{ "info" | translate }}</small></a
        >
      </li>
    </ul>

    <!-- ---------------------------- Videos Module ---------------------------- -->
    <ul *ngIf="!splitScreenOn && selectedModule === 'videos'" class="nav">
      <li class="nav-item">
        <a
          class="nav-link d-flex flex-column align-items-center disabled"
          routerLinkActive="active"
          routerLink="videos/live"
          data-cy="detailSummaryNav"
        >
          <i class="icon-files"></i>
          <small class="mt-1">{{ "live" | translate }}</small>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link d-flex flex-column align-items-center disabled"
          routerLinkActive="active"
          routerLink="videos/immersive"
          data-cy="detailSummaryNav"
        >
          <i class="icon-files"></i>
          <small class="mt-1">{{ "immersive" | translate }}</small>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link d-flex flex-column align-items-center"
          routerLinkActive="active"
          routerLink="videos/static"
          data-cy="detailSummaryNav"
        >
          <i class="icon-files"></i>
          <small class="mt-1">{{ "static" | translate }}</small>
        </a>
      </li>
    </ul>
    <router-outlet></router-outlet>
  </app-card-medium>
</div>
